import React from 'react';
import { translate } from "../../vendors/react-translate/ReactTranslate";
import mixPanelService from '../../services/mixPanel/mixPanelService';
import { EVENTS } from '../../services/mixPanel/mixPanelEvents';

const MailIcon = ({ active }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M4 6.5C4 5.67 4.67 5 5.5 5h13C19.33 5 20 5.67 20 6.5v11c0 .83-.67 1.5-1.5 1.5h-13C4.67 19 4 18.33 4 17.5v-11Z"
      stroke={active ? "#42C0B4" : "#4B5563"}
      strokeWidth="1.8"
    />
    <path
      d="m5.2 7 6.2 5.15a1 1 0 0 0 1.28 0L18.8 7"
      stroke={active ? "#42C0B4" : "#4B5563"}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const PhoneIcon = ({ active }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M7.2 4.8c.5-.5 1.3-.5 1.8 0l1.9 1.9c.5.5.5 1.3 0 1.8l-1.1 1.1c-.2.2-.3.6-.2.9.9 2.2 2.6 4 4.9 4.9.3.1.6 0 .9-.2l1.1-1.1c.5-.5 1.3-.5 1.8 0l1.9 1.9c.5.5.5 1.3 0 1.8l-1.2 1.2c-.8.8-2 1.1-3.1.9-2.7-.6-5.1-2-7.1-4-2-2-3.4-4.4-4-7.1-.2-1.1.1-2.3.9-3.1l1.2-1.2Z"
      stroke={active ? "#42C0B4" : "#4B5563"}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ToggleSwitch = ({ toggleOtpPrompt, otpPrompt, t, language, isPatientMobile }) => {
  const isHebrew = language === 'he';
  
  const firstOption = isPatientMobile ? {
    text: t("login.otp.txt"),
    isActive: otpPrompt,
    onClick: () => {
      if (!otpPrompt) {
        toggleOtpPrompt(false);
        mixPanelService.trackSwitchToggle(EVENTS.OTP);
      }
    }
  } : {
    text: t("login.otp.userandpassword"),
    isActive: !otpPrompt,
    onClick: () => {
      if (otpPrompt) {
        toggleOtpPrompt(true);
        mixPanelService.trackSwitchToggle(EVENTS.USER_AND_PASSWORD);
      }
    }
  };

  const secondOption = isPatientMobile ? {
    text: t("login.otp.userandpassword"),
    isActive: !otpPrompt,
    onClick: () => {
      if (otpPrompt) {
        toggleOtpPrompt(true);
        mixPanelService.trackSwitchToggle(EVENTS.USER_AND_PASSWORD);
      }
    }
  } : {
    text: t("login.otp.txt"),
    isActive: otpPrompt,
    onClick: () => {
      if (!otpPrompt) {
        toggleOtpPrompt(false);
        mixPanelService.trackSwitchToggle(EVENTS.OTP);
      }
    }
  };

  return (
    <div className={`toggle-switch ${isHebrew ? 'rtl' : 'ltr'}`}>
      <button
        type="button"
        className={`toggle-option ${firstOption.isActive ? 'active' : ''}`} 
        onClick={firstOption.onClick}
      >
        <span className="toggle-option-icon">
          {firstOption.text === t("login.otp.userandpassword") ? (
            <MailIcon active={firstOption.isActive} />
          ) : (
            <PhoneIcon active={firstOption.isActive} />
          )}
        </span>
        {firstOption.text}
      </button>
      <button
        type="button"
        className={`toggle-option ${secondOption.isActive ? 'active' : ''}`} 
        onClick={secondOption.onClick}
      >
        <span className="toggle-option-icon">
          {secondOption.text === t("login.otp.userandpassword") ? (
            <MailIcon active={secondOption.isActive} />
          ) : (
            <PhoneIcon active={secondOption.isActive} />
          )}
        </span>
        {secondOption.text}
      </button>
    </div>
  );
};

export default translate("login")(ToggleSwitch);
